import { gql } from '@apollo/client';

export const getConversationBySidQuery = gql(`
  query conversationBySid($sid: ID!) {
    conversationBySid(sid: $sid) {
      id
      recordings {
        completedOn
        contentType
        createdOn
        duration
        id
        name
        type
      }
      sessions {
        key
        value {
          createdOn
          status
          endedInfo {
            endedBy
            endedOn
            message
            reason
            type
          }
        }
      }
    }
  }
`);
